import $ from 'jquery'
$(document).ready(function (){
    /*$(".mega-menu-list ul li.nav-item").on('click', function (){
        $(this).find(".clini-submenu").toggle();
        $(this).find("a > i").addClass("fa-chevron-right");
        console.log("dooooooooooooo")
    })*/
})
